import { useAuthStore, useSettingsStore } from "@/stores";

export default (to, from, next) => {
  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();

  if (!authStore.isAuthenticated) {
    const url = new URL(to.path, window.location.origin);

    Object.keys(to.query).forEach((key) => {
      if (key === "directlyToUnilogin") {
        return;
      }

      url.searchParams.append(key, to.query[key] ?? "");
    });

    const redirectUrl = url.toString().substring(window.location.origin.length);

    return next({
      name: "login",
      query: {
        redirectUrl: redirectUrl,
        directlyToUnilogin: to.query?.directlyToUnilogin
      }
    });
  }

  // If user has not selected a primary institution, then we need the user to select it.
  if (!authStore.user.primaryInstitutionId && to.name !== "institutions") {
    settingsStore.setActiveLanguageGroup(undefined);

    return next({ name: "institutions" });
  }

  next();
};
